export enum KeyItemId {
    Factory = 'Factory',
    StrongerWeapons = 'StrongerWeapons',
    CombatEfficiency = 'CombatEfficiency',
    WheelOfFortune = 'WheelOfFortune',
    WheelOfButter = 'WheelOfButter',
    Synergy = 'Synergy',
    Wheel = 'Wheel',
    MassMurder = 'MassMurder',
    Victory = 'Victory'
}
